module.exports = __webpack_public_path__ + "static/media/verktygsboden-404.428a9f4a.webp";